import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import ResponsivePagination from 'react-responsive-pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCommentDots, faFile, faFileSignature, faFilter, faHistory, faPlus, faRefresh, faTimes, faTrashAlt, faUpload } from '@fortawesome/free-solid-svg-icons';
import PromotoraService, { PromotoraContratoTemplateDTO } from '../../../services/promotoraService';
import MatrizService from '../../../services/matrizService';
import ParametrosService from '../../../services/parametrosService';
import IntegracaoService from '../../../services/integracaoService';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';
import { MatrizDTO } from '../../../shared/dto/matrizDTO';
import { PromotoraGestaoAcaoDTO } from '../../../shared/dto/promotoraGestaoAcaoDTO';
import { PromotoraDocumentoDTO } from '../../../shared/dto/promotoraDocumentoDTO';
import { PromotoraParecerDTO } from '../../../shared/dto/promotoraParecerDTO';
import Spinner from '../../../shared/spinner';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import PromotoraDocumentacaoModal from './promotoraDocumentacaoModal';
import PromotoraJornadaModal from './promotoraJornadaModal';
import PromotoraContratoTemplateModal from './promotoraContratoTemplateModal';

type AcaoGestao = 'APROVAR_ANALISE' | 'APROVAR' | 'REPROVAR' | 'MAIS_DOCUMENTACAO' | 'ENVIAR_CONTRATO';
const normalizarBooleano = (valor: any) => valor === true || valor === 1 || valor === '1' || valor === 'true';
const extrairMensagemErro = (err: any, fallback: string) => {
  const data = err?.response?.data;
  if (typeof data === 'string') return data;
  if (data?.mensagem) return data.mensagem;
  if (data?.message) return data.message;
  return err?.message || fallback;
};

const statusGestaoOptions = [
  { value: '', label: 'Todos' },
  { value: 'PENDENTE_DADOS_COMPLEMENTARES', label: 'Pendente dados complementares' },
  { value: 'PENDENTE_DOCUMENTACAO', label: 'Pendente documentação' },
  { value: 'DOCUMENTACAO_PARCIAL', label: 'Documentação parcial' },
  { value: 'PENDENTE_ANALISE', label: 'Pendente análise' },
  { value: 'ANALISE_JURIDICA', label: 'Análise jurídica' },
  { value: 'ENVIADO_ASSINATURA', label: 'Enviado para assinatura' },
  { value: 'PENDENTE_APROVACAO', label: 'Pendente aprovação' },
  { value: 'APROVADA', label: 'Aprovada' },
  { value: 'REPROVADA', label: 'Reprovada' },
  { value: 'MAIS_DOCUMENTACAO', label: 'Mais documentação' }
];

const AUTO_REFRESH_GESTAO_PROMOTORA_MS = 30000;

function PromotoraGestaoComponent() {
  useVerificaPermissao();

  const promotoraService = new PromotoraService();
  const matrizService = new MatrizService();
  const parametrosService = new ParametrosService();
  const integracaoService = new IntegracaoService();

  const [loading, setLoading] = useState(true);
  const [promotoras, setPromotoras] = useState<PromotoraDTO[]>([]);
  const [matrizes, setMatrizes] = useState<MatrizDTO[]>([]);
  const [funcionalidadeAtiva, setFuncionalidadeAtiva] = useState(true);
  const [analiseJuridicaAtiva, setAnaliseJuridicaAtiva] = useState(false);
  const [docSignAtivo, setDocSignAtivo] = useState(false);
  const [alert, setAlert] = useState<{ type: 'success' | 'warning' | 'danger', text: string } | null>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 10;

  const [filtrosOpen, setFiltrosOpen] = useState(false);
  const [matrizFiltro, setMatrizFiltro] = useState('');
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [cnpjFiltro, setCnpjFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');
  const [statusGestaoFiltro, setStatusGestaoFiltro] = useState('');
  const [statusOrigemFiltro, setStatusOrigemFiltro] = useState('');

  const [promotoraSelecionada, setPromotoraSelecionada] = useState<PromotoraDTO | null>(null);
  const [documentacaoOpen, setDocumentacaoOpen] = useState(false);
  const [jornadaOpen, setJornadaOpen] = useState(false);
  const [templatesOpen, setTemplatesOpen] = useState(false);
  const [acaoOpen, setAcaoOpen] = useState(false);
  const [acaoAtual, setAcaoAtual] = useState<AcaoGestao | null>(null);
  const [observacao, setObservacao] = useState('');
  const [salvandoAcao, setSalvandoAcao] = useState(false);
  const [documentosCorrecao, setDocumentosCorrecao] = useState<PromotoraDocumentoDTO[]>([]);
  const [codigosChecklistCorrecao, setCodigosChecklistCorrecao] = useState<number[]>([]);
  const [idsDocumentosCorrecao, setIdsDocumentosCorrecao] = useState<string[]>([]);
  const [incluirNovoDocumento, setIncluirNovoDocumento] = useState(false);
  const [nomesNovosDocumentos, setNomesNovosDocumentos] = useState<string[]>(['']);
  const [nomeArquivoContrato, setNomeArquivoContrato] = useState('');
  const [arquivoContratoBase64, setArquivoContratoBase64] = useState('');
  const [templatesContrato, setTemplatesContrato] = useState<PromotoraContratoTemplateDTO[]>([]);
  const [idTemplateContrato, setIdTemplateContrato] = useState('');
  const [gerandoContratoTemplate, setGerandoContratoTemplate] = useState(false);
  const [parecerOpen, setParecerOpen] = useState(false);
  const [pareceres, setPareceres] = useState<PromotoraParecerDTO[]>([]);
  const [novoParecer, setNovoParecer] = useState('');

  const montarFiltros = () => {
    const filtrosData: any = {};
    if (matrizFiltro) filtrosData.matriz = matrizFiltro;
    if (codigoFiltro) filtrosData.codigo = codigoFiltro;
    if (nomeFiltro) filtrosData.nome = nomeFiltro;
    if (cnpjFiltro) filtrosData.cnpj = cnpjFiltro;
    if (cidadeFiltro) filtrosData.cidade = cidadeFiltro;
    if (statusGestaoFiltro) filtrosData.statusGestao = statusGestaoFiltro;
    if (statusOrigemFiltro !== '') filtrosData.ativo = statusOrigemFiltro;
    return filtrosData;
  };

  const listarPromotorasGestao = async (page = 1, filtrosOverride?: any, preservarAlerta = false, silencioso = false) => {
    try {
      if (!silencioso) {
        setLoading(true);
      }
      if (!preservarAlerta) {
        setAlert(null);
      }
      const response = await promotoraService.listarPromotorasGestao(page - 1, pageSize, filtrosOverride || montarFiltros());
      const data = response.data;
      setPromotoras(data.content || data || []);
      setTotalPages(data.totalPages || 1);
      setCurrentPage(page);
    } catch (err: any) {
      if (!silencioso) {
        setAlert({ type: 'danger', text: extrairMensagemErro(err, 'Erro ao listar promotoras para gestão.') });
        setPromotoras([]);
      }
    } finally {
      if (!silencioso) {
        setLoading(false);
      }
    }
  };

  const carregarParametros = async () => {
    try {
      const response = await parametrosService.listarTodosParametros();
      const ativo = normalizarBooleano(response.data?.gestaoPromotora ?? response.data?.gestao_promotora);
      const juridicaAtiva = normalizarBooleano(response.data?.gestaoPromotoraAnaliseJuridica ?? response.data?.gestao_promotora_analise_juridica);
      setFuncionalidadeAtiva(ativo);
      setAnaliseJuridicaAtiva(juridicaAtiva);
      try {
        const docSignResp = await integracaoService.verificarIntegracaoAtiva('DOCSIGN');
        setDocSignAtivo(Boolean(docSignResp.data));
      } catch {
        setDocSignAtivo(false);
      }
      return ativo;
    } catch (err) {
      console.error("Erro ao carregar parâmetros:", err);
      setFuncionalidadeAtiva(false);
      return false;
    }
  };

  const carregarMatrizes = async () => {
    try {
      const response = await matrizService.listarTodasMatrizesAtivas();
      setMatrizes(response.data || []);
    } catch (err) {
      console.error("Erro ao carregar matrizes:", err);
    }
  };

  const formatarCNPJ = (valor: string): string => {
    valor = valor.replace(/\D/g, '');
    valor = valor.replace(/^(\d{2})(\d)/, '$1.$2');
    valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    valor = valor.replace(/\.(\d{3})(\d)/, '.$1/$2');
    valor = valor.replace(/(\d{4})(\d)/, '$1-$2');
    return valor.slice(0, 18);
  };

  const formatarStatusGestao = (status?: string) => {
    const encontrado = statusGestaoOptions.find((item) => item.value === status);
    return encontrado?.label || status?.replace(/_/g, ' ') || '-';
  };

  const getStatusGestaoClass = (status?: string) => {
    const statusClassMap: Record<string, string> = {
      PENDENTE_DADOS_COMPLEMENTARES: 'bg-secondary',
      PENDENTE_DOCUMENTACAO: 'bg-warning text-dark',
      DOCUMENTACAO_PARCIAL: 'bg-primary',
      PENDENTE_ANALISE: 'bg-info text-dark',
      ANALISE_JURIDICA: 'bg-dark',
      ENVIADO_ASSINATURA: 'bg-primary',
      PENDENTE_APROVACAO: 'bg-info text-dark',
      APROVADA: 'bg-success',
      REPROVADA: 'bg-danger',
      MAIS_DOCUMENTACAO: 'bg-primary'
    };

    return status ? statusClassMap[status] || 'bg-secondary' : 'bg-secondary';
  };

  const permiteReenvioContrato = (item?: PromotoraDTO | null) => Boolean(item?.permiteReenvioContratoAssinatura);

  const getStatusAssinaturaContrato = (item?: PromotoraDTO | null) => (
    item?.statusAssinaturaContratoDescricao || item?.statusAssinaturaContrato?.replace(/_/g, ' ') || ''
  );

  const limparFiltros = () => {
    setMatrizFiltro('');
    setCodigoFiltro('');
    setNomeFiltro('');
    setCnpjFiltro('');
    setCidadeFiltro('');
    setStatusGestaoFiltro('');
    setStatusOrigemFiltro('');
    listarPromotorasGestao(1, {});
  };

  const abrirDocumentacao = (item: PromotoraDTO) => {
    setPromotoraSelecionada(item);
    setDocumentacaoOpen(true);
  };

  const abrirJornada = (item: PromotoraDTO) => {
    setPromotoraSelecionada(item);
    setJornadaOpen(true);
  };

  const abrirAcao = async (item: PromotoraDTO, acao: AcaoGestao) => {
    setPromotoraSelecionada(item);
    setAcaoAtual(acao);
    setObservacao('');
    setDocumentosCorrecao([]);
    setCodigosChecklistCorrecao([]);
    setIdsDocumentosCorrecao([]);
    setIncluirNovoDocumento(false);
    setNomesNovosDocumentos(['']);
    setNomeArquivoContrato('');
    setArquivoContratoBase64('');
    setIdTemplateContrato('');
    setAlert(null);
    setAcaoOpen(true);

    if (acao === 'MAIS_DOCUMENTACAO') {
      try {
        const response = await promotoraService.listarDocumentosPromotora(item.id!);
        setDocumentosCorrecao(response.data || []);
      } catch (err: any) {
        setAlert({ type: 'danger', text: extrairMensagemErro(err, 'Erro ao carregar documentos para correção.') });
      }
    }
    if (acao === 'ENVIAR_CONTRATO') {
      await carregarTemplatesContrato();
    }
  };

  const getAcaoTitulo = () => {
    if (acaoAtual === 'APROVAR_ANALISE') return 'Aprovar análise';
    if (acaoAtual === 'APROVAR') return 'Aprovar promotora';
    if (acaoAtual === 'REPROVAR') return 'Reprovar promotora';
    if (acaoAtual === 'ENVIAR_CONTRATO') {
      return permiteReenvioContrato(promotoraSelecionada)
        ? 'Reenviar contrato para assinatura'
        : 'Enviar contrato para assinatura';
    }
    return 'Incluir/Corrigir documentação';
  };

  const alternarDocumentoCorrecao = (documento: PromotoraDocumentoDTO, checked: boolean) => {
    if (documento.documentoAdicional && documento.id) {
      setIdsDocumentosCorrecao((prev) => checked ? [...prev, documento.id!] : prev.filter((id) => id !== documento.id));
      return;
    }
    if (documento.codigoChecklist) {
      setCodigosChecklistCorrecao((prev) => checked ? [...prev, documento.codigoChecklist] : prev.filter((codigo) => codigo !== documento.codigoChecklist));
    }
  };

  const documentoCorrecaoSelecionado = (documento: PromotoraDocumentoDTO) => {
    if (documento.documentoAdicional && documento.id) return idsDocumentosCorrecao.includes(documento.id);
    return codigosChecklistCorrecao.includes(documento.codigoChecklist);
  };

  const atualizarNomeNovoDocumento = (index: number, valor: string) => {
    setNomesNovosDocumentos((prev) => prev.map((nome, i) => i === index ? valor : nome));
  };

  const adicionarNomeNovoDocumento = () => {
    setNomesNovosDocumentos((prev) => [...prev, '']);
  };

  const removerNomeNovoDocumento = (index: number) => {
    setNomesNovosDocumentos((prev) => {
      const atualizados = prev.filter((_, i) => i !== index);
      return atualizados.length > 0 ? atualizados : [''];
    });
  };

  const abrirParecer = async (item: PromotoraDTO) => {
    setPromotoraSelecionada(item);
    setNovoParecer('');
    setPareceres([]);
    setParecerOpen(true);
    try {
      const response = await promotoraService.listarPareceresPromotora(item.id!);
      setPareceres(response.data || []);
    } catch (err: any) {
      setAlert({ type: 'danger', text: extrairMensagemErro(err, 'Erro ao carregar pareceres.') });
    }
  };

  const registrarParecer = async () => {
    if (!promotoraSelecionada?.id || !novoParecer.trim()) return;
    const dto = new PromotoraParecerDTO();
    dto.idPromotora = Number(promotoraSelecionada.id);
    dto.parecer = novoParecer.trim();

    try {
      await promotoraService.registrarParecerPromotora(dto);
      setNovoParecer('');
      const response = await promotoraService.listarPareceresPromotora(promotoraSelecionada.id);
      setPareceres(response.data || []);
      setAlert({ type: 'success', text: 'Parecer registrado com sucesso.' });
    } catch (err: any) {
      setAlert({ type: 'danger', text: extrairMensagemErro(err, 'Erro ao registrar Parecer.') });
    }
  };

  const carregarArquivoContrato = (file?: File) => {
    setIdTemplateContrato('');
    if (!file) {
      setNomeArquivoContrato('');
      setArquivoContratoBase64('');
      return;
    }

    setNomeArquivoContrato(file.name);
    const reader = new FileReader();
    reader.onload = () => {
      const resultado = String(reader.result || '');
      setArquivoContratoBase64(resultado.includes(',') ? resultado.split(',').pop() || '' : resultado);
    };
    reader.readAsDataURL(file);
  };

  const carregarTemplatesContrato = async () => {
    try {
      const response = await promotoraService.listarTemplatesContratoPromotora();
      setTemplatesContrato(response.data || []);
    } catch {
      setTemplatesContrato([]);
    }
  };

  const nomeArquivoTemplate = (nome?: string) => `${String(nome || 'contrato')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase() || 'contrato'}.html`;

  const htmlParaBase64 = (html: string) => {
    const bytes = new TextEncoder().encode(html);
    const tamanhoBloco = 0x8000;
    let binario = '';
    for (let indice = 0; indice < bytes.length; indice += tamanhoBloco) {
      const bloco = bytes.subarray(indice, indice + tamanhoBloco);
      binario += String.fromCharCode(...Array.from(bloco));
    }
    return window.btoa(binario);
  };

  const selecionarTemplateContrato = async (idTemplate: string) => {
    setIdTemplateContrato(idTemplate);
    if (!idTemplate) {
      setNomeArquivoContrato('');
      setArquivoContratoBase64('');
      return;
    }

    const template = templatesContrato.find((item) => String(item.id) === idTemplate);
    if (!template) return;

    setGerandoContratoTemplate(true);
    try {
      const response = await promotoraService.preVisualizarTemplateContratoPromotora(
        template,
        promotoraSelecionada?.id ?? undefined,
      );
      const templateGerado = response.data || {};
      if (templateGerado.arquivoBase64) {
        const nomeArquivo = templateGerado.nomeArquivo
          || template.nomeArquivo
          || `${nomeArquivoTemplate(template.nome).replace(/\.html$/i, '')}.${templateGerado.extensaoArquivo || template.extensaoArquivo || 'pdf'}`;
        setNomeArquivoContrato(nomeArquivo);
        setArquivoContratoBase64(templateGerado.arquivoBase64);
        return;
      }

      const html = templateGerado.htmlPreVisualizacao || template.corpoHtml || '';
      setNomeArquivoContrato(nomeArquivoTemplate(template.nome));
      setArquivoContratoBase64(htmlParaBase64(html));
    } catch (err: any) {
      setAlert({ type: 'danger', text: extrairMensagemErro(err, 'Erro ao gerar contrato pelo template.') });
      setNomeArquivoContrato('');
      setArquivoContratoBase64('');
    } finally {
      setGerandoContratoTemplate(false);
    }
  };

  const executarAcao = async () => {
    if (!promotoraSelecionada?.id || !acaoAtual) return;
    if (!observacao.trim()) {
      setAlert({ type: 'warning', text: 'Informe a observação para concluir a ação.' });
      return;
    }

    const dto = new PromotoraGestaoAcaoDTO();
    dto.idPromotora = Number(promotoraSelecionada.id);
    dto.observacao = observacao.trim();
    let alertaSucesso: { type: 'success' | 'warning'; text: string } = {
      type: 'success',
      text: 'Ação registrada com sucesso.'
    };

    if (acaoAtual === 'MAIS_DOCUMENTACAO') {
      const nomesNovosDocumentosValidos = nomesNovosDocumentos.map((nome) => nome.trim()).filter(Boolean);
      if (codigosChecklistCorrecao.length === 0 && idsDocumentosCorrecao.length === 0 && !incluirNovoDocumento) {
        setAlert({ type: 'warning', text: 'Selecione documentos para correção ou inclua um novo documento.' });
        return;
      }
      if (incluirNovoDocumento && nomesNovosDocumentosValidos.length === 0) {
        setAlert({ type: 'warning', text: 'Informe ao menos um novo documento.' });
        return;
      }
      dto.codigosChecklistCorrecao = codigosChecklistCorrecao;
      dto.idsDocumentosCorrecao = idsDocumentosCorrecao;
      dto.incluirNovoDocumento = incluirNovoDocumento;
      dto.nomesNovosDocumentos = nomesNovosDocumentosValidos;
      dto.nomeNovoDocumento = nomesNovosDocumentosValidos[0] || '';
    }

    if (acaoAtual === 'ENVIAR_CONTRATO') {
      if (!nomeArquivoContrato || !arquivoContratoBase64) {
        setAlert({ type: 'warning', text: 'Anexe o contrato para enviar a assinatura.' });
        return;
      }
      dto.nomeArquivoContrato = nomeArquivoContrato;
      dto.arquivoContratoBase64 = arquivoContratoBase64;
    }

    setSalvandoAcao(true);
    try {
      if (acaoAtual === 'APROVAR_ANALISE') {
        await promotoraService.aprovarAnalisePromotoraGestao(dto);
      } else if (acaoAtual === 'APROVAR') {
        await promotoraService.aprovarPromotoraGestao(dto);
      } else if (acaoAtual === 'REPROVAR') {
        await promotoraService.reprovarPromotoraGestao(dto);
      } else if (acaoAtual === 'ENVIAR_CONTRATO') {
        const response = await promotoraService.enviarContratoAssinaturaPromotora(dto);
        const enviado = Boolean(response.data?.enviado);
        alertaSucesso = {
          type: enviado ? 'success' : 'warning',
          text: response.data?.mensagem || (enviado
            ? 'Contrato anexado e enviado para assinatura com sucesso.'
            : 'Contrato anexado, mas não enviado para assinatura.')
        };
      } else {
        await promotoraService.solicitarMaisDocumentacaoPromotora(dto);
      }

      setAcaoOpen(false);
      setPromotoraSelecionada(null);
      await listarPromotorasGestao(currentPage, undefined, true);
      setAlert(alertaSucesso);
    } catch (err: any) {
      setAlert({ type: 'danger', text: extrairMensagemErro(err, 'Erro ao registrar ação.') });
    } finally {
      setSalvandoAcao(false);
    }
  };

  useEffect(() => {
    const iniciar = async () => {
      const ativo = await carregarParametros();
      await carregarMatrizes();
      if (ativo) {
        await listarPromotorasGestao(1);
      } else {
        setLoading(false);
      }
    };

    iniciar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!funcionalidadeAtiva) {
      return;
    }

    const intervalId = window.setInterval(() => {
      listarPromotorasGestao(currentPage, undefined, true, true);
    }, AUTO_REFRESH_GESTAO_PROMOTORA_MS);

    return () => window.clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    funcionalidadeAtiva,
    currentPage,
    matrizFiltro,
    codigoFiltro,
    nomeFiltro,
    cnpjFiltro,
    cidadeFiltro,
    statusGestaoFiltro,
    statusOrigemFiltro
  ]);

  return (
    <div className="position-relative m-md-3">
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h5>Origens &gt; Gestão Promotora</h5>
        <div className="d-flex gap-2">
          {funcionalidadeAtiva && (
            <Button variant="outline-secondary" onClick={() => setTemplatesOpen(true)}>
              <FontAwesomeIcon icon={faFileSignature} style={{ marginRight: '10px' }} />
              Templates de contrato
            </Button>
          )}
          <Button id="App-button-cor-principal-escura" onClick={() => setFiltrosOpen(!filtrosOpen)} disabled={!funcionalidadeAtiva}>
            <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
            Filtros
          </Button>
        </div>
      </div>

      {alert && <Alert variant={alert.type}>{alert.text}</Alert>}

      {!funcionalidadeAtiva && (
        <Alert variant="warning">
          Funcionalidade desativada nos parâmetros de TI.
        </Alert>
      )}

      {funcionalidadeAtiva && filtrosOpen && (
        <>
          <Row className="mb-4" style={{ marginTop: '15px' }}>
            <Form.Group as={Col} md='2'>
              <Form.Label>Matriz</Form.Label>
              <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                <option value="">Selecione</option>
                {matrizes.map((matriz) => (
                  <option key={matriz.id} value={String(matriz.id)}>
                    {matriz.id} - {matriz.nome}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='2'>
              <Form.Label>Código</Form.Label>
              <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md='3'>
              <Form.Label>Nome</Form.Label>
              <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md='3'>
              <Form.Label>CNPJ</Form.Label>
              <input type="text" className="form-control" value={cnpjFiltro} onChange={(e) => setCnpjFiltro(formatarCNPJ(e.target.value))} maxLength={18} />
            </Form.Group>
            <Form.Group as={Col} md='2'>
              <Form.Label>Cidade</Form.Label>
              <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md='3' className="mt-3">
              <Form.Label>Status Gestão</Form.Label>
              <Form.Select value={statusGestaoFiltro} onChange={(e) => setStatusGestaoFiltro(e.target.value)}>
                {statusGestaoOptions.map((item) => (
                  <option key={item.value || 'todos'} value={item.value}>{item.label}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='3' className="mt-3">
              <Form.Label>Status Origem</Form.Label>
              <Form.Select value={statusOrigemFiltro} onChange={(e) => setStatusOrigemFiltro(e.target.value)}>
                <option value="">Todas</option>
                <option value="true">Ativas</option>
                <option value="false">Inativas</option>
              </Form.Select>
            </Form.Group>
          </Row>
          <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <Button id="App-button-cor-principal-escura" onClick={() => listarPromotorasGestao(1)}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
              Aplicar
            </Button>
            <Button variant="secondary" onClick={limparFiltros}>
              <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '5px' }} />
              Limpar
            </Button>
          </div>
        </>
      )}

      {loading ? <Spinner loading={loading} /> : funcionalidadeAtiva && (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th id="App-header-table">Promotora</th>
                <th id="App-header-table">CNPJ</th>
                <th id="App-header-table">Cidade</th>
                <th id="App-header-table">Matriz</th>
                <th id="App-header-table">Status Origem</th>
                <th id="App-header-table">Status Gestão</th>
                <th id="App-header-table">Documentação</th>
                <th id="App-header-table">Jornada</th>
                <th id="App-header-table">Parecer</th>
                <th id="App-header-table">Contrato</th>
                <th id="App-header-table">Aprovar</th>
                <th id="App-header-table">Reprovar</th>
                <th id="App-header-table">Mais Docs</th>
              </tr>
            </thead>
            <tbody>
              {promotoras.map((item) => {
                const permiteAnalise = item.statusGestao === 'PENDENTE_ANALISE';
                const permiteAprovacaoGeral = item.statusGestao === 'PENDENTE_APROVACAO';
                const reenvioContrato = permiteReenvioContrato(item);
                const statusContrato = getStatusAssinaturaContrato(item);
                const permiteContratoInicial = item.statusGestao === 'ANALISE_JURIDICA' && analiseJuridicaAtiva;
                const permiteContrato = permiteContratoInicial || (analiseJuridicaAtiva && reenvioContrato);
                const permiteAcao = permiteAnalise || permiteAprovacaoGeral;
                const permiteReprovarOuMaisDocs = permiteAcao || permiteContratoInicial;
                return (
                  <tr key={item.id}>
                    <td>{item.id} - {item.nome}</td>
                    <td>{item.cnpj}</td>
                    <td>{item.cidade}</td>
                    <td>{item.matriz ? `${item.matriz} - ${item.nomeMatriz}` : '-'}</td>
                    <td>
                      <span className={`badge ${item.ativo ? 'bg-success' : 'bg-secondary'}`}>
                        {item.ativo ? 'Ativa' : 'Inativa'}
                      </span>
                    </td>
                    <td>
                      <span className={`badge ${getStatusGestaoClass(item.statusGestao)}`}>
                        {item.statusGestaoDescricao || formatarStatusGestao(item.statusGestao)}
                      </span>
                    </td>
                    <td>
                      <Button size="sm" id="App-button-cor-principal" onClick={() => abrirDocumentacao(item)} title="Documentação">
                        <FontAwesomeIcon icon={faFile} className="me-1" />
                        {item.documentosAnexados ?? 0}/{item.documentosObrigatorios ?? 0}
                      </Button>
                    </td>
                    <td>
                      <Button size="sm" id="App-button-cor-principal" onClick={() => abrirJornada(item)} title="Jornada">
                        <FontAwesomeIcon icon={faHistory} />
                      </Button>
                    </td>
                    <td>
                      <Button size="sm" variant="outline-secondary" onClick={() => abrirParecer(item)} title="Parecer">
                        <FontAwesomeIcon icon={faCommentDots} />
                      </Button>
                    </td>
                    <td>
                      <div className="d-flex flex-column align-items-center gap-1">
                        <Button
                          size="sm"
                          variant={reenvioContrato ? 'warning' : 'outline-primary'}
                          onClick={() => abrirAcao(item, 'ENVIAR_CONTRATO')}
                          disabled={!permiteContrato}
                          title={reenvioContrato ? `Reenviar contrato${statusContrato ? ` (${statusContrato})` : ''}` : 'Enviar contrato'}
                        >
                          <FontAwesomeIcon icon={faUpload} />
                        </Button>
                        {statusContrato && (
                          <small className="text-muted text-nowrap">{statusContrato}</small>
                        )}
                      </div>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="success"
                        onClick={() => abrirAcao(item, permiteAnalise ? 'APROVAR_ANALISE' : 'APROVAR')}
                        disabled={!permiteAcao}
                        title={permiteAnalise ? 'Aprovar análise' : 'Aprovar'}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </Button>
                    </td>
                    <td>
                      <Button size="sm" variant="danger" onClick={() => abrirAcao(item, 'REPROVAR')} disabled={!permiteReprovarOuMaisDocs} title="Reprovar">
                        <FontAwesomeIcon icon={faTimes} />
                      </Button>
                    </td>
                    <td>
                      <Button size="sm" variant="warning" onClick={() => abrirAcao(item, 'MAIS_DOCUMENTACAO')} disabled={!permiteReprovarOuMaisDocs} title="Solicitar mais documentação">
                        <FontAwesomeIcon icon={faRefresh} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
              {promotoras.length === 0 && (
                <tr>
                  <td colSpan={13} className="text-center text-muted">Nenhuma promotora encontrada.</td>
                </tr>
              )}
            </tbody>
          </table>

          <ResponsivePagination
            current={currentPage}
            total={totalPages}
            onPageChange={(page) => listarPromotorasGestao(page)}
          />
        </div>
      )}

      <PromotoraDocumentacaoModal
        show={documentacaoOpen}
        promotora={promotoraSelecionada}
        somenteConsulta
        somentePendentesInicial={promotoraSelecionada?.statusGestao === 'MAIS_DOCUMENTACAO'}
        onHide={() => setDocumentacaoOpen(false)}
        onUpdated={() => listarPromotorasGestao(currentPage)}
      />

      <PromotoraJornadaModal
        show={jornadaOpen}
        promotora={promotoraSelecionada}
        onHide={() => setJornadaOpen(false)}
      />

      <PromotoraContratoTemplateModal
        show={templatesOpen}
        onHide={() => setTemplatesOpen(false)}
      />

      <Modal show={acaoOpen} onHide={() => setAcaoOpen(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{getAcaoTitulo()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <strong>{promotoraSelecionada?.id} - {promotoraSelecionada?.nome}</strong>
          </div>
          <Form.Group>
            <Form.Label>Observação <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              maxLength={1000}
              required
            />
          </Form.Group>
          {acaoAtual === 'ENVIAR_CONTRATO' && (
            <>
              {!docSignAtivo && (
                <div className="alert alert-warning mt-3 mb-0">
                  Integração DocSign inativa. O contrato poderá ser anexado, mas não será enviado para assinatura.
                </div>
              )}
              {templatesContrato.length > 0 && (
                <Form.Group className="mt-3">
                  <Form.Label>Template de contrato</Form.Label>
                  <Form.Select
                    value={idTemplateContrato}
                    disabled={gerandoContratoTemplate}
                    onChange={(e) => selecionarTemplateContrato(e.target.value)}
                  >
                    <option value="">Selecionar template...</option>
                    {templatesContrato.map((item) => (
                      <option key={item.id} value={item.id}>{item.nome}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
              <Form.Group className="mt-3">
                <Form.Label>Contrato <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.doc,.docx,.html"
                  onChange={(e: any) => carregarArquivoContrato(e.target.files?.[0])}
                />
                {nomeArquivoContrato && (
                  <div className="text-muted mt-2">{nomeArquivoContrato}</div>
                )}
              </Form.Group>
            </>
          )}
          {acaoAtual === 'MAIS_DOCUMENTACAO' && (
            <div className="mt-3">
              <Form.Label>Documentações para correção</Form.Label>
              <div className="border rounded p-2" style={{ maxHeight: '360px', overflowY: 'auto' }}>
                {documentosCorrecao.map((documento) => {
                  const desabilitado = !documento.id && !documento.codigoChecklist;
                  return (
                    <Form.Check
                      key={`${documento.documentoAdicional ? 'adicional' : 'checklist'}-${documento.id || documento.codigoChecklist}`}
                      type="checkbox"
                      className="mb-2"
                      disabled={desabilitado}
                      checked={documentoCorrecaoSelecionado(documento)}
                      onChange={(e) => alternarDocumentoCorrecao(documento, e.target.checked)}
                      label={`${documento.codigoChecklist ? `${documento.codigoChecklist}. ` : ''}${documento.nomeChecklist || documento.descricaoDocumento} (${documento.statusChecklist || 'PENDENTE'})`}
                    />
                  );
                })}
                {documentosCorrecao.length === 0 && (
                  <div className="text-muted">Nenhum documento encontrado.</div>
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <Form.Check
                  type="checkbox"
                  label="Incluir novo documento"
                  checked={incluirNovoDocumento}
                  onChange={(e) => setIncluirNovoDocumento(e.target.checked)}
                />
                {incluirNovoDocumento && (
                  <Button size="sm" variant="outline-secondary" onClick={adicionarNomeNovoDocumento} title="Adicionar novo documento">
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Adicionar
                  </Button>
                )}
              </div>
              {incluirNovoDocumento && (
                <div className="mt-2">
                  {nomesNovosDocumentos.map((nomeNovoDocumento, index) => (
                    <div key={`novo-documento-${index}`} className="d-flex align-items-center mb-2" style={{ gap: '8px' }}>
                      <Form.Control
                        placeholder={`Nome do novo documento ${index + 1}`}
                        value={nomeNovoDocumento}
                        onChange={(e) => atualizarNomeNovoDocumento(index, e.target.value)}
                        maxLength={255}
                      />
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => removerNomeNovoDocumento(index)}
                        disabled={nomesNovosDocumentos.length === 1}
                        title="Remover documento"
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAcaoOpen(false)} disabled={salvandoAcao}>
            Cancelar
          </Button>
          <Button id="App-button-cor-principal-escura" onClick={executarAcao} disabled={salvandoAcao || !observacao.trim()}>
            {salvandoAcao ? <Spinner loading={true} /> : 'Confirmar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={parecerOpen} onHide={() => setParecerOpen(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Parecer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <strong>{promotoraSelecionada?.id} - {promotoraSelecionada?.nome}</strong>
          </div>
          <div className="border rounded p-2 mb-3" style={{ maxHeight: '260px', overflowY: 'auto' }}>
            {pareceres.map((item) => (
              <div key={item.id} className="border-bottom pb-2 mb-2">
                <div className="small text-muted">
                  {item.nomeUsuario || '-'} - {item.dtInclusao ? new Date(item.dtInclusao).toLocaleString('pt-BR') : '-'}
                </div>
                <div>{item.parecer}</div>
              </div>
            ))}
            {pareceres.length === 0 && (
              <div className="text-muted">Nenhum Parecer registrado.</div>
            )}
          </div>
          <Form.Group>
            <Form.Label>Novo Parecer</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={novoParecer}
              onChange={(e) => setNovoParecer(e.target.value)}
              maxLength={2000}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setParecerOpen(false)}>
            Fechar
          </Button>
          <Button id="App-button-cor-principal-escura" onClick={registrarParecer} disabled={!novoParecer.trim()}>
            Registrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PromotoraGestaoComponent;
